module.exports = __webpack_public_path__ + "static/media/img-scope7.78b6d57c.png";